import AuditBlock from "../../components/personal/AuditTestPage/AuditBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const AuditPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Аудит"}>
            <AuditBlock/>
        </TypicalPageStructure>
        </>
    )
}

export default AuditPage;